
import React, { FC, useMemo } from "react";
import { Table, } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/lib/table";
import { useDeliveryDetailsModel } from "./deliveryDetailsModel"
import { RouterParamType } from "@/model/navModel";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
export const DeliveryList: FC<RouterParamType> = ({ id, mode }) => {
    const {
        deliveryLookList,
        deliveryEditList,
        loading
    } = useDeliveryDetailsModel()
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            align: "center",
            render: (t, r, i) => <>{i + 1}</>
        },
        {
            title: '配件编码',
            width: 180,
            align: "center",
            dataIndex: 'materialCode',
        },
        {
            title: '配件名称',
            width: 180,
            align: "center",
            dataIndex: 'materialName',
        }, {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        },
        {
            title: '库存数量',
            width: 180,
            align: "center",
            dataIndex: 'inventoryNum',
        },
        {
            title: '出库数量',
            width: 180,
            align: "center",
            dataIndex: 'num',
        },
        {
            title: '所属仓库',
            width: 180,
            align: "center",
            dataIndex: 'warehouseName',
        },
        {
            title: '所属货位',
            width: 180,
            align: "center",
            dataIndex: 'shelfCode',
        },
        {
            title: '出库日期',
            width: 180,
            align: "center",
            dataIndex: 'stockIoTime',
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockDelivery", "roleCodes": roles };
        return getRoleColumns("stockDelivery", "出库记录", columns, params);
    }, [roles, deliveryEditList, deliveryLookList]);

    return (
        <>
            <YhBox>
                <Table
                    bordered
                    loading={loading}
                    rowKey={record => record.id as string}
                    columns={roleColumns}
                    pagination={false}
                    dataSource={mode === "edit" ? deliveryEditList : deliveryLookList}
                    scroll={{ x: 'max-content', y: 400 }}
                />
            </YhBox>
        </>
    )
}